import React, { useEffect, useState } from "react";
import { Link } from "@mui/material";
import { images } from "../../../config/images";
import "./OurSegment.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { oursegment } from "../../../config/services";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../../utils/slugify";

const OurSegment = ({ settingAPIDataChild, headerAPIDataChild }) => {
  const [oursegmentData, setOurSegmentData] = useState([]);

  useEffect(() => {
    hanleoursegment();
  }, []);

  const hanleoursegment = async () => {
    try {
      const resp = await oursegment();
      if (resp.data.code === 200 || resp.data.code === 201) {
        setOurSegmentData(resp.data.responseBody);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };
  const navigate = useNavigate();
  return (
    <>
      <div className="section-padding"></div>
      <div className="our-segment-background">
        <div>
          <img
            src={images.rightSpirrel}
            alt="segment-module"
            className="segment-module"
          />
        </div>
        <div className="common-sec">
          <header className="our-segment-header-block">
            <span className="our-segment-badge">Our Segment</span>
            <h2 className="our-segment-heading">True Healthcare For Your Family!</h2>
            <p className="our-segment-subline">Specialized divisions dedicated to better patient outcomes.</p>
          </header>

          <div className="our-segment-slider-wrap">
            <Slider {...settings}>
            {oursegmentData && oursegmentData.length > 0
              ? oursegmentData.map((data) => (
                <div className="our-segment-box" key={data?.id}>
                  <div className="segment-icon-wrap">
                    <img src={data.image} alt={data?.title} className="segment-img" />
                  </div>
                  <h3 className="our-segment-name">{data?.title}</h3>
                  <Link className="segmnet-a" underline="none" onClick={() => navigate(`/division/${slugify(data?.title)}`, { state: { category_id: data.id, navTitle: data.title } })}>
                    <span className="read-more-link-segment">Read More</span>
                  </Link>
                </div>
              ))
              : Array.from({ length: 6 }).map((_, index) => (
                <div className="our-segment-box" key={index}>
                  <div className="segment-icon-wrap"><div className="shimmer-img" /></div>
                  <div className="shimmer-title" />
                  <div className="shimmer-button" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurSegment;
